import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const AccountReceivable = {
	name: NAME,
	apiProvider,
	router,
};
